export enum DataType {
  PERCENTAGE1 = 'percentage1',
  PERCENTAGE1_ROUNDED = 'percentage1rounded',
  CURRENCY = 'currency',
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  DATETIME = 'datetime',
}

export enum FormatLocaleOptions {
  PERCENT = 'percent',
  CURRENCY = 'currency',
  DECIMAL = 'decimal',
}

export enum AggregateBy {
  FAMILY = 'family',
  CLIENT = 'client',
}

export enum AggregateFieldType {
  BANK_ID = 'bank_id',
  BANKER_ID = 'banker_id',
  TEAM_ID = 'team_id',
  MARKET_ID = 'market_id',
  CLIENT_ID = 'client_id',
  FAMILY_ID = 'family_id',
  // TODO - Find better place for PROSPECT as its
  // not used for Aggregates but filtering on the FE
  PROSPECT = 'prospectCustomSelection',
  CREATED_BY = 'CREATED_BY',
}

export enum ViewMode {
  SELF = 'self',
  OTHER = 'other',
}

export enum ViewType {
  BANK = 'bank',
  BANKER = 'banker',
  TEAM = 'team',
  MARKET = 'market',
  CLIENT = 'client',
  FAMILY = 'family',
  PROSPECT = 'prospect',
}

export enum ClientType {
  PRIVATE = 'PRIVATE',
  INTERMEDIATED = 'INTERMEDIATED',
  INTERMEDIARY = 'INTERMEDIARY',
  UNKNOWN = 'UNKNOWN',
}

export enum PortfolioStatus {
  UNACCEPTABLE = 'UNACCEPTABLE',
  UNSATISFACTORY = 'UNSATISFACTORY',
  BELOW = 'BELOW',
  AVERAGE = 'AVERAGE',
  TARGET = 'TARGET',
  UNKNOWN = 'UNKNOWN',
  LOSS_MAKING = 'LOSS_MAKING',
  BREAK_EVEN = 'BREAK_EVEN',
  PROFITABLE = 'PROFITABLE',
  CHURN_PREVENTION = 'CHURN_PREVENTION',
  SALES_OPPORTUNITY = 'SALES_OPPORTUNITY',
  CAMPAIGN = 'CAMPAIGN',
  NO_ACTION = 'NO_ACTION',
}

export enum PortfolioStatusType {
  PROFIT = 'PROFIT',
  REVENUE = 'REVENUE',
  NBA = 'NBA',
}

export const RevenueStatus = [
  PortfolioStatus.TARGET,
  PortfolioStatus.AVERAGE,
  PortfolioStatus.BELOW,
  PortfolioStatus.UNSATISFACTORY,
  PortfolioStatus.UNACCEPTABLE,
  PortfolioStatus.UNKNOWN,
];

export const ProfitStatus = [
  PortfolioStatus.PROFITABLE,
  PortfolioStatus.BREAK_EVEN,
  PortfolioStatus.LOSS_MAKING,
  PortfolioStatus.UNKNOWN,
];

export const NBAStatus = [
  PortfolioStatus.CHURN_PREVENTION,
  PortfolioStatus.SALES_OPPORTUNITY,
  PortfolioStatus.CAMPAIGN,
  PortfolioStatus.NO_ACTION,
  PortfolioStatus.UNKNOWN,
];

export const PortfolioStatusesByType = {
  [PortfolioStatusType.PROFIT]: ProfitStatus,
  [PortfolioStatusType.REVENUE]: RevenueStatus,
  [PortfolioStatusType.NBA]: NBAStatus,
};

export enum Service {
  EXECUTION = 'EXECUTION',
  ADVISORY = 'ADVISORY',
  DISCRETIONARY = 'DISCRETIONARY',
}

export enum ServiceOrder {
  EXECUTION = '1',
  ADVISORY = '2',
  DISCRETIONARY = '3',
}

export const Services = [
  Service.EXECUTION,
  Service.ADVISORY,
  Service.DISCRETIONARY,
];

export enum SectionType {
  CURRENCY = 'currency',
  CREDIT = 'credit',
  HEADING = 'heading',
}

export enum DiscountType {
  FIXED_RATE_DISCOUNT = 'FIXED_RATE_DISCOUNT',
  FEE_DISCOUNT = 'FEE_DISCOUNT',
}

// BE ReviewStatus & ScenarioApprovalStatus
export enum ApprovalStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  UNKNOWN = 'UNKNOWN',
  PENDING = 'PENDING',
}

// BE OpportunityApprovalStatus
export enum OpportunityStatus {
  SUBMITTED = 'SUBMITTED',
  ANTE_APPROVED = 'ANTE_APPROVED',
  ANTE_REJECTED = 'ANTE_REJECTED',
  IMPLEMENTED = 'IMPLEMENTED',
  CLIENT_REJECTED = 'CLIENT_REJECTED',
  POST_APPROVED = 'POST_APPROVED',
  POST_REJECTED = 'POST_REJECTED',
}

// BE ScenarioApprovalAction & PricingApprovalAction
export enum ApprovalAction {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  VIEW = 'VIEW',
  DISMISS = 'DISMISS',
}

export enum ScenarioHistoryActionType {
  SCENARIO_SUBMISSION_ACTION = 'SCENARIO_SUBMISSION_ACTION',
  APPROVAL_ACTION = 'APPROVAL_ACTION',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
}

export enum ScenarioHistorySubActionType {
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  SUBMIT = 'SUBMIT',
  APPROVAL = 'APPROVAL',
}

export enum NameResolutionType {
  CLIENT = 'CLIENT',
  CONTAINER = 'CONTAINER',
  COLLECTION = 'COLLECTION',
  LEAD = 'LEAD',
  LEAD_INTERMEDIARY = 'LEAD_INTERMEDIARY',
  BANKER = 'BANKER',
}

export enum PortfolioType {
  PORTFOLIO = 'PORTFOLIO',
  PROSPECT = 'PROSPECT',
}

export enum KpiInformationFieldType {
  KEY_VALUE_PAIR = 'KEY_VALUE_PAIR',
  CLIENT_FAMILY = 'CLIENT_FAMILY',
}

export enum ClientViewType {
  PORTFOLIO_VIEW = 'PORTFOLIO_VIEW',
  SCENARIO_VIEW = 'SCENARIO_VIEW',
  PROSPECT_VIEW = 'PROSPECT_VIEW',
  PROSPECT_PORTFOLIO_VIEW = 'PROSPECT_PORTFOLIO_VIEW',
}

export enum FieldType {
  DROPDOWN = 'DROPDOWN',
  TEXTAREA = 'TEXTAREA',
  HIDDEN = 'HIDDEN',
  DATE_PICKER = 'DATE_PICKER',
  INPUT = 'INPUT',
  SEARCH_INPUT = 'SEARCH_INPUT',
  TEXT = 'TEXT',
  RADIO_SELECT = 'RADIO_SELECT',
  SELECT = 'SELECT',
  STATUS = 'STATUS',
  CHECKBOX = 'CHECKBOX',
  CHECKBOX_LARGE = 'CHECKBOX_LARGE',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  TIME_PICKER = 'TIME_PICKER',
}

export enum RowDisplayType {
  TOTAL_ROW = 'totalRow',
  HIDDEN = 'hidden',
}

export enum FieldDisplayType {
  HEADING = 'heading',
  HEADING_WITH_VALUES = 'headingWithValues',
  HIDDEN = 'hidden',
  DIAMOND_STATUS_INDICATOR = 'diamondStatusIndicator',
  FLOWER_STATUS_INDICATOR = 'flowerStatusIndicator',
}

export enum VisibilityType {
  SCENARIO_ONLY = 'scenarioOnly',
  PROSPECT_ONLY = 'prospectOnly',
  FEATURE_PROFIT_MODE_ONLY = 'featureProfitModeOnly',
  FEATURE_REVENUE_MODE_ONLY = 'featureRevenueModeOnly',
  FEATURE_FAMILY_LEVEL_MODE_ONLY = 'featureFamilyLevelModeOnly',
  FEATURE_PORTFOLIO_LEVEL_MODE_ONLY = 'featurePortfolioLevelModeOnly',
}

export enum BannerType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export enum Direction {
  RIGHT = 'right',
  LEFT = 'left',
}

export enum SearchType {
  INTERMEDIARY = 'intermediary_id',
  FAMILY = 'family_id',
  CLIENT = 'client_id',
  MAIN_CLIENT = 'main_client_id',
  PORTFOLIO = 'portfolio_id',
  CLIENT_NAME = 'client_name',
  LEAD = 'lead_id',
  FUNNEL = 'funnel',
  CAMPAIGN = 'utm_campaign',
}

export enum ReportingViewMode {
  BANK_VIEW = 'BANK_VIEW',
  MARKET_VIEW = 'MARKET_VIEW',
  TEAM_VIEW = 'TEAM_VIEW',
  BANKER_VIEW = 'BANKER_VIEW',
}
